import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'
import { theme, ifProp } from 'styled-tools'
import { media } from '../../../ui/rwd'
import { Card, Button } from 'reactstrap'
import { MdLocalShipping } from 'react-icons/md'

import ProductImageSlider from '../Store/ProductImageSlider/ProductImageSlider'
import SoldRibbonBase from '../Store/SoldRibbon/SoldRibbon'
import BaseProductPrice from '../Store/ProductPrice/ProductPrice'
import BaseProductDescription from '../Store/ProductDescription/ProductDescription'
import BaseProductName from '../Store/ProductName/ProductName'
import RemoveButtonBase from '../Store/RemoveButton/RemoveButton'
import AddButtonBase from '../Store/AddButton/AddButton'
import { FormattedMessage } from 'react-intl'

const ProductCard = styled(Card)`
  border: 0 !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  width: 100%;
  overflow: auto !important;
  background-color: ${theme('seashell')} !important;
  height: auto;
  ${media.sm`
    border-radius: 5px !important;
    margin: auto;
    overflow: hidden;
    height: 420px;
  `}
`

const ProductGrid = styled.div`
  display: grid;
  min-height: 350px;
  height: 100%;
  grid-gap: 4px;
  background-color: ${theme('storeBackgroundColor')};
  font-variant: tabular-nums;
  grid-template:
    'slider slider' minmax(max-content, max-content)
    'header header' minmax(max-content, max-content)
    'description description' auto
    'counter backtostore' auto
    'suboptions suboptions' max-content
    'buynow shippable' auto
    / 1fr 1fr;
  ${media.sm`
 padding: 10px;
  grid-template:
  "slider header header" minmax(min-content, max-content)
  "slider counter backtostore" 65px
  "slider suboptions suboptions" minmax(150px, max-content)
  "slider buynow shippable" auto
  / auto 1fr 1fr;
`};
`

const Slider = styled(ProductImageSlider)`
  grid-area: slider;
  display: flex;
  ${media.sm`
  margin: 0px;
`}

  &.slick-slider {
    text-align: center;
    height: auto;
    width: auto;

    ${media.sm`
    width: 400px !important;
  `}
  }
`

const SoldRibbon = styled(SoldRibbonBase)`
  min-width: 20px !important;
  width: 10rem !important;
  left: -2.2rem;
  right: auto;
  top: 1.8rem;
  bottom: auto;
  color: ${theme('productPlusButtonIcon')};
  background-color: ${theme('productPlusButtonBackground')} !important;
  ${media.sm.down`
    transform: rotate(0deg);
    left: 15px;
    top: 4.8rem;
  `};
`

const ProductHeader = styled.div`
  grid-area: header;
  background-color: white;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  align-items: left;
  padding: 1rem 1rem 1rem 1rem;
  ${media.sm`
    padding:1rem;
  `};
`

const ProductName = styled(BaseProductName)`
  font-family: inherit;
  font-weight: 500;
  font-size: 1.5rem;
  flex-grow: 1;
`

const Price = styled(BaseProductPrice)`
  display: inline;
  margin-left: 15px;
  text-align: right;
  font-size: 1.5rem;
  z-index: 20;
  // position: relative;
  overflow: hidden;
  align-self: flex-end;
  margin-bottom: 0;
  padding: 3px;
  height: 100%;
  border: ${ifProp('isWholesale', '2px solid green', 'auto')};
`

const ProductDescription = styled.div`
  background-color: white !important;
  padding: 1rem 1rem 1rem 1rem;
  flex: 1;
  ${media.sm`
    max-height: 140px;
    overflow: auto;
  `};
`
const ProductDescriptionParagraph = styled(BaseProductDescription)``

const ProductSubOptions = styled.div`
  background-color: white !important;
  grid-area: suboptions;
  padding: 1rem 1rem 1rem 1rem;
  ${media.sm`
    overflow: auto;
  `};
`

const ArtDescription = styled.div`
  background-color: white !important;
  grid-area: suboptions;
  padding: 1rem 1rem 1rem 1rem;
  overflow: auto;
  ${media.sm`
    max-height: 140px;
  `};
`

const ArtDescriptionPara = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const ArtDescriptionHeaderLine = styled.div`
  font-size: 1rem;
  font-weight: bold;
  width: 50%;
`
const ArtDescriptionLine = styled.div`
  font-size: 1rem;
  width: 50%;
`

const CounterSection = styled.div`
  display: flex;
  align-items: center;
  grid-area: counter;
  justify-content: center;
  padding: 0;
`

const RemoveButton = styled(RemoveButtonBase)`
  height: 2.5rem;
`

const AddButton = styled(AddButtonBase)`
  height: 2.5rem;
`

const AddToCartButton = styled(Button)`
  grid-area: counter;
  text-transform: uppercase;
  margin: 10px;
  height: 45px;
  &.btn {
    background-color: #9b9b9b !important;
    font-size: 0.8rem;
  }
`

const BackToStoreButton = styled(Button)`
  grid-area: backtostore;
  text-transform: uppercase;
  margin: 10px 10px 10px 0;
  height: 45px;
  &.btn {
    font-size: 0.8rem;
    color: ${theme('addProductButtonText', 'white')};
    background-color: ${theme('addProductButtonBg', '#9EDAE4')} !important;
  }
  ${media.sm`
    margin: 10px 0 10px 0;
   `}
`

const BuyItNowButton = styled(Button)`
  grid-area: buynow;
  text-transform: uppercase;
  margin: 10px;
  height: 45px;
  &.btn {
    font-size: 0.9rem;
    white-space: nowrap;
    color: ${theme('addProductButtonText', 'white')};
    background-color: ${theme('addProductButtonBg', '#9EDAE4')} !important;
  }
`

const ProductsCount = styled.span`
  border-radius: 40px;
  background-color: white;
  position: relative;
  font-weight: 400;
  height: 35px;
  width: 35px;
  margin-left: 0.4rem;
  margin-right: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
`

const ShipableBox = styled.div`
  grid-area: shippable;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8125rem;
  font-weight: 400;
  margin-bottom: 0;
  min-height: 50px;
  background-color: white;
  .shipping-icon {
    margin-right: 0.5rem;
  }
`

const ShippableIcon = styled(MdLocalShipping)`
  color: ${theme('stockBannerBackground')};
  height: 30px;
  width: auto;
  margin-right: 15px;
`

const Shippable = ({ show, product }) => {
  return (
    show && (
      <ShipableBox>
        <ShippableIcon id={product.getId() + 3} />
        <FormattedMessage id='productDetails.modal.shipAble' />
      </ShipableBox>
    )
  )
}

Shippable.propTypes = {
  show: PropTypes.bool,
  product: PropTypes.object.isRequired
}

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  // Hide checkbox visually but remain accessible to screen readers.
  // Source: https://polished.js.org/docs/#hidevisually
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`
const Checkmark = styled.svg`
  fill: none;
  stroke: ${theme('addProductButtonBg', '#9EDAE4')};
  stroke-width: 2px;
`

const StyledCheckbox = styled.div`
  display: inline-block;
  width: 16px;
  // height: 16px;
  background: white;
  border-radius: 3px;
  transition: all 150ms;
  box-shadow: 0 0 0 3px ${theme('addProductButtonBg', '#9EDAE4')};
  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px pink;
  }
  ${Checkmark} {
    visibility: ${props => props.checked ? 'visible' : 'hidden'}
  }
`

const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`

const SubOptionContainer = styled.label`
  display: flex;
  flex-direction: row;
`

export {
  ProductCard,
  ProductGrid,
  Slider,
  SoldRibbon,
  ProductHeader,
  ProductName,
  Price,
  ProductDescription,
  ProductDescriptionParagraph,
  ProductSubOptions,
  AddToCartButton,
  CounterSection,
  RemoveButton,
  AddButton,
  BuyItNowButton,
  ProductsCount,
  Shippable,
  ArtDescriptionLine,
  ArtDescription,
  ArtDescriptionHeaderLine,
  ArtDescriptionPara,
  HiddenCheckbox,
  StyledCheckbox,
  CheckboxContainer,
  Checkmark,
  SubOptionContainer,
  BackToStoreButton
}
